<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/finance'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      validationSummary: [],
      formModel: {
        //  SetDefault: false,
        Code: "",
        Description: "",
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
        RecordId: "",
      },
      data: {
        title: "GL Auto post Accounts",
        pageRoute: "/gl-auto-post-accounts",
        saveEndPoint: "Save_GLFactor",
        recordEndPoint: "GLFactor",
        exportFileName: "GL Auto post Accounts List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "GLFactor",
              // expand: "GLChart",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.GLFactorPostProcess,
            },
            rowSelect: {
              view: this,
              page: "gl-auto-post-accounts",
              mode: "review",
              idProperty: "Code",
              idMode: "Number",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
          },
          columns: [
            {
              screenField: "Code",
              dataField: "CodeComputedString",
              allowHiding: false,
            },
            {
              screenField: "Comments",
              dataField: "Comment",
              label: "Description",
            },
            {
              screenField: "GLChart",
              // dataField: "GLChartCodeComputedString",
              label: "GL Account",
              dataField: "GLChartCodeComputedString",
              cellTemplate: "Record",

              cellTemplateRecord: {
                image: false,
                primary: [
                  {
                    dataField: "GLChartCodeComputedString",
                  },
                ],
                secondary: [
                  {
                    dataField: "GLChartDescription",
                  },
                ],
              },

              exportFields: [
                {
                  dataField: "GLChartCodeComputedString",
                  label: "GL Account Code",
                },
                {
                  dataField: "GLChartDescription",
                  label: "GL Account Description",
                },
              ],
            },
            {
              screenField: "Date",
              dataField: "DateChanged",
              label: "Date Changed",
            },
            {
              dataField: "ChangedBy",
              label: "Changed By",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [],
        },
      },
      setLoading: false,
    };
  },
  computed: {
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              allowUpdate: false,

              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Code",
                dataField: "Code",
                required: true,
                allowUpdate: this.baseView.mode == "edit" ? false : true,
                isPrimaryKeyField: true,
              },

              {
                screenField: "GLChart",
                cellTemplate: undefined,
                dataField: "GLChartCode",
                label: {
                  text: "GL Account",
                },
                // dataField: "GLChartCodeComputedString",
                valueExpr: "Code",
                displayExpr: "ComputedStringCode",
                searchExpr: [
                  "ComputedStringCode",
                  "Description",
                  "ParentGLChartDescription",
                ],

                // dataSourceConfig: {
                //   endpoint: "api/GLChart",
                //   sort: {
                //     selector: "Description",
                //     asc: true,
                //   },
                //   filter: [["Inactive", "=", "N"], "and", ["Status", "=", "A"]],
                //   select: ["Code", "ComputedStringCode", "Description", "ParentGLChartDescription"]
                // },
              },
              {
                screenField: "Comments",
                dataField: "Comment",
                label: "Description",
                visible: false,
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    GLFactorPostProcess(data) {
      data.forEach((element) => {
        if (element.GLChartDescription == "N/A")
          element["GLChartDescription"] = "";
      });

      return data;
    },
  },
};
</script>
